module.exports = __webpack_public_path__ + "static/img/2-2-6.fc19028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/serviceContent/2-2-6.jpg
// module id = m9D3
// module chunks = 1